import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ProfileAvatarModule } from '@app/profile';
import { HeaderMenuModule } from '@app/shell/header/menu/menu.module';
import { IconComponent } from '@app/tw-shared/components';
import { MenuButtonDirective, NavItemDirective } from '@app/tw-shared/directives';
import { DropdownOpenCloseService } from '@app/tw-shared/directives/dropdown-open-close/dropdown-open-close.service';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, map, Subscription, tap } from 'rxjs';
import { NavItemMeService } from '../../services';
import { DataTestModule } from '@app/shared/directive/data-test';
import { NotificationsRedbubbleService } from '@app/notifications';
import { UserService } from '@app/user';

@Component({
    selector: 'app-nav-item-me',
    imports: [CommonModule, IconComponent, TranslateModule, MenuButtonDirective, ProfileAvatarModule, HeaderMenuModule, DataTestModule, NavItemDirective],
    templateUrl: './nav-item-me.component.html',
    styleUrl: './nav-item-me.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NavItemMeService,
        {
            provide: DropdownOpenCloseService,
            useFactory: () => new DropdownOpenCloseService('dropdown'),
        },
    ]
})
export class NavItemMeComponent implements OnInit, OnDestroy {
    @Input({ required: true }) position: number;
    readonly hover$ = new BehaviorSubject<boolean>(false);

    private readonly navItemMeService = inject(NavItemMeService);
    private readonly dropdownOpenCloseService = inject(DropdownOpenCloseService);

    readonly open$ = this.dropdownOpenCloseService.openEvent$;
    readonly active$ = this.navItemMeService.active$;
    readonly listId = this.navItemMeService.listId;

    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly subscriptions = new Subscription();

    private readonly userService = inject(UserService);
    readonly canAccessNotifications$ = this.userService.access$.pipe(map((access) => access.includes('notifications')));

    private readonly notificationsRedbubbleService = inject(NotificationsRedbubbleService);

    get notificationCount(): number {
        return this.notificationsRedbubbleService.count;
    }

    ngOnInit(): void {
        this.subscriptions.add(this.notificationsRedbubbleService.updates.pipe(tap(() => this.changeDetectorRef.detectChanges())).subscribe());
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
